var mobile = require('is-mobile');

export default function footerNav() {

    if (mobile({tablet: true}) && wenpriseSettings.enableFooterCollapse === 'yes') {
        $('.footer-widget-area .widget-title').click(function() {
            $(this).toggleClass('is-active');
            $(this).next().slideToggle();
        });
    }

}
